var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "qr-code-style-wrapper" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(_setup.CSelect, {
          staticClass: "col-6",
          attrs: {
            label: "Shape",
            options: _setup.QR_SHAPES,
            "model-transform": _setup.valueReducer,
            disabled: _setup.disabled,
          },
          on: { input: _setup.onShapeSelected },
          model: {
            value: _setup.model.shape,
            callback: function ($$v) {
              _vm.$set(_setup.model, "shape", $$v)
            },
            expression: "model.shape",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 d-flex align-items-center" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                type: "number",
                label: "Margin",
                min: _setup.MIN_MARGIN,
                max: _setup.MAX_MARGIN,
                disabled: _setup.disabled,
              },
              on: { blur: _setup.onMarginChanged },
              model: {
                value: _setup.model.margin,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "margin", $$v)
                },
                expression: "model.margin",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(_setup.CSelect, {
          staticClass: "col-12",
          attrs: {
            label: "Dots style",
            options: _setup.QR_DOTS_TYPES,
            "model-transform": _setup.valueReducer,
            disabled: _setup.disabled,
          },
          on: { input: _setup.onDotsTypeSelected },
          model: {
            value: _setup.model.dotsType,
            callback: function ($$v) {
              _vm.$set(_setup.model, "dotsType", $$v)
            },
            expression: "model.dotsType",
          },
        }),
        _vm._v(" "),
        _c(_setup.CSelect, {
          staticClass: "col-6",
          attrs: {
            label: "Corner square style",
            options: _setup.QR_CORNERS_SQUARE_TYPES,
            "model-transform": _setup.valueReducer,
            disabled: _setup.disabled,
          },
          on: { input: _setup.onCornersSquareTypeSelected },
          model: {
            value: _setup.model.cornersSquareType,
            callback: function ($$v) {
              _vm.$set(_setup.model, "cornersSquareType", $$v)
            },
            expression: "model.cornersSquareType",
          },
        }),
        _vm._v(" "),
        _c(_setup.CSelect, {
          staticClass: "col-6",
          attrs: {
            label: "Corner dot style",
            options: _setup.QR_CORNERS_DOT_TYPES,
            "model-transform": _setup.valueReducer,
            disabled: _setup.disabled,
          },
          on: { input: _setup.onCornersDotTypeSelected },
          model: {
            value: _setup.model.cornersDotType,
            callback: function ($$v) {
              _vm.$set(_setup.model, "cornersDotType", $$v)
            },
            expression: "model.cornersDotType",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }